import type { ReactNode } from "react";
import type { PerimetreWithoutTerritoire } from "models";
import { Link, Skeleton } from "@mui/material";
import { COLLECTIVITES_APP_DOMAIN_NAME } from "config/app-config";
import CompetenceChip from "components/CompetenceChip";

interface PerimetreLinkProps {
  perimetre: PerimetreWithoutTerritoire;
  isLoading?: boolean;
  dense?: boolean;
}

export function PerimetreLink({
  perimetre,
  isLoading = false,
  dense = false,
}: Readonly<PerimetreLinkProps>): ReactNode {
  if (isLoading) {
    return <Skeleton />;
  }

  return (
    <Link
      target="_blank"
      href={`https://${COLLECTIVITES_APP_DOMAIN_NAME}/perimetre/${perimetre.id}`}>
      <CompetenceChip competence={perimetre.competence} sx={{ mr: 1 }} />
      {perimetre.code}
      {!dense && ` - ${perimetre.libelle}`}
    </Link>
  );
}
